<template>
    <div>
        <img src="../../assets/logotable.png" style="position:fixed;top:0.8rem;z-index:9;height:1.5rem;right:50vw;">
        <nav-bar title="我的报名"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" class="my-nav"/>
        <div class="grey-box" >
            <div style="margin-top: 45px"></div>
            <cell-group title="我的报名" v-if="list.length" >
                <cell :title="v.activityName" is-link v-for="(v,i) in list" :key="i" @click="toDetail(v)"/>
            </cell-group>
            <pagination v-model="page" :total-items="total" mode="simple" @change="init()" v-if="list.length"/>
            <empty v-else description="暂无数据"/>
        </div>
    </div>
</template>

<script>
    import {Cell, CellGroup, NavBar, Col,Pagination,Empty} from 'vant';
    import service from "../../api/service";
    //我的活动
    export default {
        name: "myList",
        components: {
            Cell, CellGroup, NavBar, Col,Empty,Pagination
        },
        data() {
            return {
                list: [],
                page: 1,
                total: 0,
                pageIndex: 1,
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            //返回
            onClickLeft() {
                this.$router.push({path: '/personalCenter'})
            },
            init() {
                service.get('/api/activity/querybyidgetuser', {
                    openid: sessionStorage.getItem("openid"),
                    page: this.page,
                }).then(res => {
                    if (res.status === 200) {
                        this.list = res.data
                        this.total = res.total
                    }
                })
            },
            toDetail(v) {
                sessionStorage.setItem("proId",v.id)
                sessionStorage.setItem("activityName",v.activityName)
                this.$router.push({path: '/moveDetail'})
            }
        }
    }
</script>

<style scoped>

</style>